module.exports = __webpack_public_path__ + "img/delayed-dosing-sm.08968c71.png";